import { Box, Grid, Stack, Typography, useTheme, styled } from '@mui/material'
import React, { FC } from 'react'
import { IMooringType } from 'src/generated-types'
import { useTranslation } from 'react-i18next'
import { getFormattedDate, getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'

interface MooringSelectCardProps {
  mooring: any
  isSelected: boolean
  onClick: () => void
}

const MooringSelectCard: FC<MooringSelectCardProps> = ({ mooring, isSelected, onClick, ...props }) => {
  const { t: translate } = useTranslation(['common', 'mooring'])
  const theme = useTheme()
  return (
    <StyledBox onClick={onClick} isSelected={isSelected} theme={theme} {...props}>
      <Typography
        variant="body1"
        fontWeight={600}
        noWrap
        height={40}
        sx={{
          color: isSelected
            ? getThemeColor(theme, MUIThemeColors.white)
            : getThemeColor(theme, MUIThemeColors.primaryDark),
        }}
      >
        {translate(IMooringType[mooring.type], { ns: 'mooring' })}
      </Typography>
      <Grid item xs={12}>
        <Stack direction="row" gap={1} justifyContent="flex-start" alignItems="flex-start">
          <Typography
            variant="body2"
            fontWeight="normal"
            sx={{
              color: isSelected
                ? getThemeColor(theme, MUIThemeColors.white)
                : getThemeColor(theme, MUIThemeColors.black),
            }}
          >
            {translate('installationDate', { ns: 'mooring' })} : {getFormattedDate(mooring.installationDate)}
          </Typography>
        </Stack>
      </Grid>
    </StyledBox>
  )
}

export default MooringSelectCard

const StyledBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSelected' && prop !== 'minwidth' && prop !== 'maxwidth' && prop !== 'height',
})<{
  minwidth?: string
  maxwidth?: string
  height?: string
  isSelected?: boolean
}>(({ minwidth, maxwidth, height, isSelected, theme }) => ({
  height: height || '72px',
  overflow: 'hidden',
  minWidth: minwidth || '246px',
  maxWidth: maxwidth,
  boxShadow: `0px 2px 8px ${getThemeColor(theme, MUIThemeColors.black)}40`,
  borderRadius: '4px',
  opacity: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '4px',
  cursor: 'pointer',
  paddingTop: '14px',
  paddingLeft: '14px',
  border: isSelected ? `2px solid ${getThemeColor(theme, MUIThemeColors.primaryMain)}` : '2px solid transparent',
  background: isSelected
    ? getThemeColor(theme, MUIThemeColors.primaryMain)
    : getThemeColor(theme, MUIThemeColors.white),
}))
